import Tag from '../Tag';
import BaseEventPayload from './BaseEventPayload';

export default class TagEventPayload extends BaseEventPayload {
  constructor(data = {}, parentEventLog) {
    super(TagEventPayload, data, parentEventLog);
    this.tag = data.tag && new Tag(data.tag);
    this.tagText = data.tagText;
  }
}
